export default "__VITE_ASSET__DFJeqVzD__"